import React from 'react'
import styled, { keyframes } from 'styled-components'

import { Div } from 'elements/layout/Div'

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

export const StyledSVG = styled.svg`
  width: 40px;
  height: 40px;
  fill: ${(props) => props.theme.colors.yellow};
  color: ${(props) => props.theme.colors.yellow};

  .loader_circle {
    transform-origin: 256px 256px;
    animation: ${rotate} 1s linear infinite;
  }

  /* cercle 1 */
  /* cercle 2 */
  /* croix Hozana au centre */
  .path1 {
    /* Cercle invisible servant à équilibrer le point central de rotation du cercle 2 */
    opacity: 0;
    fill: ${(props) => props.theme.colors.yellow};
  }
  .path2 {
    opacity: 1;
  }
`

export const Loading: TFC = () => (
  <Div p="10px" align="center">
    <StyledSVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <title>loader</title>
      <g className="loader_circle">
        <path
          className="path1"
          d="M503.7,259.1a19,19,0,0,0-13.13-6.55c-.45,0-.91,0-1.35,0a19.16,19.16,0,0,0-19.06,17.8,213.63,213.63,0,0,1-62.38,137.52c-83.67,83.67-219.8,83.67-303.47,0s-83.67-219.8,0-303.47A213.64,213.64,0,0,1,241.84,42a19.14,19.14,0,0,0-1.38-38.24c-.41,0-.89,0-1.32,0a252.8,252.8,0,0,0-161.75,431A252.79,252.79,0,0,0,508.35,273,19,19,0,0,0,503.7,259.1Z"
        />
        <path
          className="path2"
          d="M8.3,252.9a19,19,0,0,0,13.13,6.55c.45,0,.91,0,1.35,0a19.16,19.16,0,0,0,19.06-17.8,213.63,213.63,0,0,1,62.38-137.52c83.67-83.67,219.8-83.67,303.47,0s83.67,219.8,0,303.47A213.64,213.64,0,0,1,270.16,470a19.14,19.14,0,0,0,1.38,38.24c.41,0,.89,0,1.32,0a252.8,252.8,0,0,0,161.75-431A252.79,252.79,0,0,0,3.65,239,19,19,0,0,0,8.3,252.9Z"
        />
      </g>
      <polygon points="272.08 240.04 272.08 115 240.17 115 240.17 240.04 115.12 240.04 115.12 271.96 240.17 271.96 240.17 397 272.08 397 272.08 271.96 397.13 271.96 397.13 240.04 272.08 240.04" />
    </StyledSVG>
  </Div>
)
